<div class="panel trailer-half">
    <span>Step 1.Choose area of interest</span>
    <mc-tabs id="mc-tabs" [tabs]="aoiTabs" (tabChanged)="onTabChange($event)">
        <div slot="tab_1">
            <mc-state #stateTab></mc-state>
        </div>
        <div slot="tab_2">
            <mc-region #regionTab (loaded)="regionsLoaded($event)"></mc-region>
        </div>
        <div slot="tab_3">
            <div class="standard-corridor-radio-buttons-container">
                <div>
                    <input type="radio" [(ngModel)]="routeSelectionType" name="routeSelectionType" value="standard" />
                    Standard
                </div>
                <div>
                    <input type="radio" [(ngModel)]="routeSelectionType" name="routeSelectionType" value="corridor" />
                    Corridor
                </div>
            </div>
            <div [hidden]="routeSelectionType !== 'corridor'" class="corridor-routes">
                <label>Route</label>
                <select name="corridorRoute" [(ngModel)]="corridorRoute">
                    <option *ngFor="let item of corridorRoutes" [value]="item">{{ item }}</option>
                </select>
            </div>
            <mc-route #routeTab [hidden]="routeSelectionType === 'corridor'" show-full-name="true"></mc-route>
            <div class="non-state-non-federal-container" *ngIf="routeSelectionType !== 'corridor'">
                <input type="checkbox" name="non-state-non-federal" [(ngModel)]="includeNonStateNonFederalAidRoutes"
                    (change)="nonStateNonFederalCheckboxChange($event)">
                Include non-state non-federal aid routes
            </div>
        </div>
        <div slot="tab_4">
            <mc-asset-search #assetIdTab></mc-asset-search>
        </div>
        <div slot="tab_5">
            <mc-address #addressTab></mc-address>
        </div>
        <div slot="tab_6">
            <mc-lat-long #latLongTab></mc-lat-long>
        </div>
    </mc-tabs>
</div>
<div class="panel trailer-half">
    <div class="panel-header">
        <span>Step 2.</span>
        <label class="toggle-switch clearfix use-existing-map" *ngIf="hasExistingLayers">
            <span class="togggle-switch-label left font-size--1 margin-right-half">Use existing Map</span>
            <input type="checkbox" name="seperate" class="toggle-switch-input" [(ngModel)]="useExistingMap" checked
                (change)="existingMapChanged($event)">
            <span class="toggle-switch-track right"></span>
        </label>
        <span *ngIf="!hasExistingLayers">Select a map template</span>
    </div>
    <mc-map-picker #mapPicker [hidden]="hasExistingLayers && useExistingMap"></mc-map-picker>
</div>
<div class="button-area">
    <div class="covid-warning">Traffic counts identified with an asterisk (*) may be under represented due to the
        COVID-19 pandemic.
    </div>
    <div class="buttons">
        <button class="btn btn-small generate" (click)="generateMap()">
            <span class="icon-ui-play"></span>
            Generate Map
        </button>
        <button class="btn btn-small cancel" (click)="closeAoiTool()">
            <span class="icon-ui-close"></span>
            Cancel
        </button>
    </div>
</div>